import angular from "angular"

export default angular.module("routeStopPopupModule", [])